import { service } from '@ember/service'
import Route from '@ember/routing/route'
import StepUtils from 'teacher-ui-client/school-rollover/step-utils'
import type SchoolRolloverService from 'teacher-ui-client/services/school-rollover'
import type RouterService from '@ember/routing/router-service'
import type StepsRoute from 'teacher-ui-client/manage/rollover/steps/route'

/**
 * @class StepRoute
 */
export default class StepRouteRoute extends Route {
  @service
  schoolRollover!: SchoolRolloverService

  @service
  router!: RouterService

  /**
   * @property stepId used by {StepRoute} to save the furthest step visited.
   */
  stepId: Nullable<string> = null

  async beforeModel() {
    const { rollover } = this.modelFor('manage.rollover.steps') as ModelFor<StepsRoute>

    const { stepId } = this

    if (!rollover || !stepId || !StepUtils.isStep(stepId)) {
      void this.router.transitionTo('manage.rollover.wizard')
      return
    }

    const canTransitionToRequestedStep = this.schoolRollover.canTransitionToStep(rollover, stepId)

    if (canTransitionToRequestedStep) {
      await this.schoolRollover.saveRolloverStepIfNew(rollover, stepId)
    } else if (this.schoolRollover.canTransitionToStep(rollover, rollover?.step)) {
      // Redirect them to the appropriate step for the current rollover record
      const routeName = StepUtils.getRouteNameForStep(rollover?.step)
      void this.router.transitionTo(routeName)
    } else {
      void this.router.transitionTo('manage.rollover.wizard')
    }
  }

  model() {
    const { rollover } = this.modelFor('manage.rollover.steps') as ModelFor<StepsRoute>
    return { rollover }
  }
}
